import "./SewerLineRepair.module.css";
import Header from "@/reusable_sections/Header";
import SewerHero from "./sections/SewerHero";
import SewerOverview from "./sections/SewerOverview";
import SewerProblems from "./sections/SewerProblems";
import SewerSigns from "./sections/SewerSigns";
import SewerMethods from "./sections/SewerMethods";
import CoreServices from "./sections/CoreServices";
import RelatedProblems from "./sections/RelatedProblems";
import JonesboroArea from "./sections/JonesboroArea";
import SewerFaq from "./sections/SewerFaq";
import SewerRequest from "./sections/SewerRequest";
import EmergencyCallToAction from "./sections/EmergencyCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SewerLineRepairPage() {
  return <div>
      <Header />
      <SewerHero />
      <SewerOverview />
      <SewerProblems />
      <SewerSigns />
      <SewerMethods />
      <CoreServices />
      <RelatedProblems />
      <JonesboroArea />
      <SewerFaq />
      <SewerRequest id="sewer-service-request-form" />
      <EmergencyCallToAction />
      <Footer />
    </div>;
}